import type {
  CompleteCheckoutRequestDto,
  ExecuteCheckinRequestDto,
  MoveStayRoomRequestDto,
  RegisterGuestDocumentRequestDto,
} from "./contracts/dtos.ts";
import type { FrontDeskInvoiceProvider } from "./invoice.ts";
import type { FrontDeskKeycardProvider } from "./keycard.ts";
import {
  completeCheckout,
  executeCheckin,
  moveStayRoom,
  registerGuestDocument,
} from "./service.ts";
import type { FrontDeskContext } from "./types.ts";

export const frontDeskEndpoints = {
  registerGuestDocument: (
    request: RegisterGuestDocumentRequestDto,
    now: string,
    deps: { idFactory: (prefix: string) => string }
  ) => registerGuestDocument(request, now, deps),
  executeCheckin: (
    request: ExecuteCheckinRequestDto,
    context: FrontDeskContext,
    deps: { idFactory: (prefix: string) => string; keycardProvider: FrontDeskKeycardProvider }
  ) => executeCheckin(request, context, deps),
  moveStayRoom: (
    request: MoveStayRoomRequestDto,
    context: FrontDeskContext,
    deps: { idFactory: (prefix: string) => string; keycardProvider: FrontDeskKeycardProvider }
  ) => moveStayRoom(request, context, deps),
  completeCheckout: (
    request: CompleteCheckoutRequestDto,
    context: FrontDeskContext,
    deps: { idFactory: (prefix: string) => string; invoiceProvider: FrontDeskInvoiceProvider }
  ) => completeCheckout(request, context, deps),
};
